export enum TicketCutoffTypeEnum {
  QuotasCetip = 1,
  QuotasTed = 2,
  PrivateFixedIncome = 3,
  PublicFixedIncome = 4,
  Contracted = 5,
  Futures = 6,
  SwapCetip = 7,
  MarginDepositPublic = 8,
  MarginDepositPrivate = 9,
  MarginDepositVariable = 10,
  MarginWithdrawalPublic = 11,
  MarginWithdrawalPrivate = 12,
  MarginWithdrawalVariable = 13,
  MarginMoney = 14,
  CurrencyTerm = 15,
  VariableIncome = 16,
  QuotasSovereign = 17,
  Loan = 18,
  Exchange = 19,
  Transfer = 20,
  Expenses = 21,
  LiabilitiesCetip = 22,
  LiabilitiesTed = 23,
  StructuredOperations = 24,
  StructuredOperationOrder = 25,
}
